/* ================================================================
   custom-override-script.js
   Review Card Slider initialisation.
   Targets the new .rcs-* class names used in
   snippets/review-slider-block.liquid
   ================================================================ */

document.addEventListener('DOMContentLoaded', initAllReviewSliders);

/* Re-init when Shopify theme editor reloads a section or block */
document.addEventListener('shopify:section:load', initAllReviewSliders);
document.addEventListener('shopify:block:select', initAllReviewSliders);

function initAllReviewSliders() {
  document.querySelectorAll('.rcs-slider-wrap').forEach(initReviewSlider);
}

function initReviewSlider(slider) {
  /* Prevent double-init on the same element */
  if (slider.dataset.rcsInit === 'true') return;
  slider.dataset.rcsInit = 'true';

  var track    = slider.querySelector('.rcs-track');
  var dotsWrap = slider.querySelector('.rcs-dots');
  var prevBtn  = slider.querySelector('.rcs-arrow--prev');
  var nextBtn  = slider.querySelector('.rcs-arrow--next');
  var cards    = slider.querySelectorAll('.rcs-card');
  var dots     = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.rcs-dot')) : [];

  if (!track || !cards.length) return;

  var total        = cards.length;
  var current      = 0;
  var autoInterval = null;

  /* ── Single slide: hide controls, nothing else needed ── */
  if (total <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    if (dotsWrap) dotsWrap.style.display = 'none';
    return;
  }

  /* ── Go to a specific slide index ── */
  function goTo(index) {
    /* wrap around */
    if (index < 0)     index = total - 1;
    if (index >= total) index = 0;

    current = index;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';

    /* update dots */
    dots.forEach(function (dot, i) {
      var active = i === current;
      dot.classList.toggle('rcs-dot--active', active);
      dot.setAttribute('aria-selected', String(active));
    });
  }

  /* ── Arrow listeners ── */
  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goTo(current - 1);
      resetAuto();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goTo(current + 1);
      resetAuto();
    });
  }

  /* ── Dot listeners ── */
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      resetAuto();
    });
  });

  /* ── Touch / swipe ── */
  var touchStartX = 0;
  slider.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  slider.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 40) {
      goTo(diff > 0 ? current + 1 : current - 1);
      resetAuto();
    }
  }, { passive: true });

  /* ── Autoplay ── */
  function startAuto() {
    autoInterval = setInterval(function () {
      goTo(current + 1);
    }, 5000);
  }

  function resetAuto() {
    clearInterval(autoInterval);
    startAuto();
  }

  slider.addEventListener('mouseenter', function () { clearInterval(autoInterval); });
  slider.addEventListener('mouseleave', startAuto);

  /* ── Keyboard navigation when slider is focused ── */
  slider.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft')  { goTo(current - 1); resetAuto(); }
    if (e.key === 'ArrowRight') { goTo(current + 1); resetAuto(); }
  });

  /* ── Bootstrap ── */
  goTo(0);
  startAuto();
}
